import { render, staticRenderFns } from "./ReportMetalCompoment.vue?vue&type=template&id=eb69f2de&scoped=true"
import script from "./ReportMetalCompoment.vue?vue&type=script&lang=js"
export * from "./ReportMetalCompoment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb69f2de",
  null
  
)

export default component.exports